import { Box, Button, MenuItem, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import FormSelect from '@Components/Form/FormSelect';

const FormSelects = () => {
  const formContext = useForm<{ name: string }>({
    defaultValues: { name: '' },
  });

  const nameOptions = [
    { label: 'John Doe', value: 'john' },
    { label: 'Jane Doe', value: 'jane' },
    { label: 'Sam Smith', value: 'sam' },
  ];

  return (
    <Box>
      <Typography variant="h3">Form Select</Typography>
      <FormProvider {...formContext}>
        <form
          onSubmit={formContext.handleSubmit((values) => {
            console.log('Form Values:', values);
          })}
        >
          <Box display={'flex'} alignItems={'flex-end'} gap={2} mt={2}>
            <FormSelect
              name="name"
              label="Name"
              placeholder="Please Select Name"
              control={formContext.control}
            >
              {nameOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </FormSelect>
            <Button type="submit">Submit</Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  );
};

export default FormSelects;
